import Request from "../../../helpers/Request";
import LanguageHelper from "../../../helpers/LanguageHelper";
import moment from "moment";

export default function FetchData(
  query,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  setNumOfEntries,
  type,
  filterProps
) {

  const language = LanguageHelper.getLanguage();
  const data = new Promise(async (resolve, reject) => {
    const params = {
      page: query.page,
      size: query.pageSize,
      sort: "id,desc",
    };
    if (query.orderBy !== undefined) {
      params.sort = query.orderBy.field;
    }

    if (query.search !== "") {
      params.search = query.search;
    }
    const resp = await Request("get", "/api/tickets", null, params);
    if (resp.status !== 200) {
      setSeverity("error");
      setSnackbarMessage(language.etc.fetchingError + resp?.data?.message);
      setSnackbar(true);
    } else {
      let otherData = resp.data;
      let data = otherData.content;
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        const edit = {
          id: data[i].id ? data[i].id : null,
          title: data[i].title ? data[i].title : null,
          lastUpdated: data[i].lastUpdated ? data[i].lastUpdated : null,
          total: data[i].total ? data[i].total : null,
          waitingForSupportCount: data[i].waitingForSupportCount ? data[i].waitingForSupportCount : null,
          inProgressCount: data[i].inProgressCount ? data[i].inProgressCount : null,
          waitingForCustomerCount: data[i].waitingForCustomerCount ? data[i].waitingForCustomerCount : null,
        };
        temp.push(edit);
      }
      setNumOfEntries(otherData.totalElements);
      resolve({
        data: temp,
        page: otherData.pageable.pageNumber,
        totalCount: otherData.totalElements,
      });
    }
  });
  return data;
}